import './style.scss';
import { Button, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { Guidances } from 'views/components/atoms/guidances';
import { Separator } from 'views/components/atoms/separator';
import { FormikProps } from 'formik/dist/types';
import { Toast, ToastProps } from 'views/components/atoms/toast';

export type SendSMSParam = {
  authenticationCode: string;
};
type SendSMSFormikType = FormikProps<SendSMSParam>;

type SendSMSTemplate = {
  formik: SendSMSFormikType;
  text?: string;
  phoneNumber: string;
  onSendSMS: () => void;
  toastProps: ToastProps;
};

export const SendSMSTemplate = ({ formik, text, phoneNumber, onSendSMS, toastProps }: SendSMSTemplate) => {
  return (
    <>
      {/* <Toast label="Toast" /> */}
      <form onSubmit={formik.handleSubmit} className="loginWrapper">
        <Guidances
          label={
            text ??
            (phoneNumber.includes('*')
              ? `"${phoneNumber}"に送信された認証コードを入力してください`
              : `末尾が ${phoneNumber} の電話番号に送信された認証コードを入力してください`)
          }
          annotation="※認証コードの有効期限は5分です"
        />

        <div className="fieldWrapper">
          <div className="loginInput">
            <span className="loginInput_label">認証コード</span>
            <input
              className="loginInput_field"
              type="text"
              inputMode="numeric"
              name="authenticationCode"
              value={formik.values.authenticationCode}
              onChange={formik.handleChange}
            />
            {!!formik.errors.authenticationCode && <span className="errorRed">{formik.errors.authenticationCode}</span>}
          </div>
        </div>
        <div className="fieldWrapper">
          <Button label="認証" type={ButtonType.Submit} fillType={FillType.primaryFill} buttonSize={ButtonSize.sizeM} />

          <Separator />

          <Button
            label="認証コードを再送信"
            type={ButtonType.Button}
            fillType={FillType.primaryEmpty}
            buttonSize={ButtonSize.sizeM}
            onClick={onSendSMS}
          />
        </div>

        <Toast {...toastProps} />
      </form>
    </>
  );
};
